import React from 'react';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import { Checkbox } from '../Checkbox';
import { Icon } from '../IconExporter';
import { Container, ItemContainer } from './styles';

type Item = {
  id: string;
  name: string;
  isSelected?: boolean;
  subItems?: Item[];
}

type TreeListProps = {
  items: Item[];
  handleSelectCallback?: (item: Item, selected?: boolean) => void;
  hasCheckbox?: boolean;
}

export const TreeList = ({ items, handleSelectCallback, hasCheckbox = false }: TreeListProps) => {
  const renderItems = (itemsToRender: Item[]) => {
    return itemsToRender.map(item => {
      const Label = <ItemContainer>
        {hasCheckbox && <Checkbox size={20} value={item?.isSelected} handleChange={(value) => handleSelectCallback(item, value)} /> }
        <p>{item.name}</p>
      </ItemContainer>
      if (item.subItems) {
        return <TreeItem nodeId={item.id} label={Label} key={item.id}>
          {renderItems(item.subItems)}
        </TreeItem>
      }
      
      return <TreeItem 
          key={item.id}
          nodeId={item.id} 
          label={Label} 
          onClick={() => {
            if (handleSelectCallback && !hasCheckbox) handleSelectCallback(item);
          }}
        />
    });
  }
  
  return <Container>
    <TreeView 
      className="treeContainer"
      defaultCollapseIcon={<Icon name="setabaixo" size={12} />}
      defaultParentIcon={<Icon name="setadireita" size={12} />}
    >
      {items && items.length > 0 && renderItems(items)}
    </TreeView>
  </Container>
}